import React from 'react';
import { LuSearch, LuX } from 'react-icons/lu';
import { cx } from '../../utils/cx.js';

const SIZES = {
  md: { input: 'h-9 pl-9 pr-9 text-sm rounded-lg', icon: 'left-3 h-4 w-4', clear: 'right-2' },
  lg: { input: 'h-11 pl-10 pr-10 text-[15px] rounded-xl', icon: 'left-3.5 h-[18px] w-[18px]', clear: 'right-2.5' },
};

/** Search field with leading icon, clear button and optional hint below. */
export function SearchInput({
  value,
  onChange,
  onKeyDown,
  inputRef,
  placeholder = 'Rechercher…',
  helpText = null,
  label,
  size = 'md',
  className = '',
  ...rest
}) {
  const sz = SIZES[size] || SIZES.md;
  return (
    <div className={className}>
      <div className="relative">
        <LuSearch className={cx('pointer-events-none absolute top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500', sz.icon)} aria-hidden />
        <input
          ref={inputRef}
          type="search"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          aria-label={label || placeholder}
          autoComplete="off"
          className={cx(
            'w-full border border-gray-200 bg-white text-gray-900 shadow-sm outline-none transition-shadow placeholder:text-gray-400',
            'focus:border-brand-400 focus:ring-4 focus:ring-brand-500/15',
            'dark:border-gray-800 dark:bg-night-800 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-brand-500',
            '[&::-webkit-search-cancel-button]:hidden',
            sz.input,
          )}
          {...rest}
        />
        {value ? (
          <button
            type="button"
            onClick={() => onChange?.('')}
            className={cx('absolute top-1/2 inline-flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-white/10 dark:hover:text-gray-200', sz.clear)}
            aria-label="Effacer la recherche"
            title="Effacer"
          >
            <LuX className="h-3.5 w-3.5" aria-hidden />
          </button>
        ) : null}
      </div>
      {helpText ? <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">{helpText}</p> : null}
    </div>
  );
}

export default SearchInput;
